import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=428b689c"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports